import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGaurd } from './shared/services/auth.gaurd';
import { BlankLayoutComponent } from './shared/components/layouts/blank-layout/blank-layout.component';
import { StudentLayoutComponent } from './shared/components/layouts/student-layout/student-layout.component';
import { TeacherLayoutComponent } from './shared/components/layouts/teacher-layout/teacher-layout.component';
import { ReportLayoutComponent } from './shared/components/layouts/report-layout/report-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full'
  },
  // {
  //   path: '',
  //   component: AuthLayoutComponent,
  //   children: [
  //     {
  //       path: 'sessions',
  //       loadChildren: './views/sessions/sessions.module#SessionsModule'
  //     }
  //   ]
  // 
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: 'signin',
        loadChildren: './views/sessions/sessions.module#SessionsModule'
      }
    ]
  },
  {
    path: '',
    component: StudentLayoutComponent,
    children: [
      {
        path: 'Student',
        loadChildren: './views/exam/exam.module#ExamModule'
      }
    ]
  },
  {
    path: '',
    component: TeacherLayoutComponent,
    children: [
      {
        path: 'Teacher',
        loadChildren: './views/teacher/teacher.module#TeacherModule'
      }
    ]
  },
  {
    path: '',
    component: ReportLayoutComponent,
    children: [
      {
        path: 'analysis-report',
        loadChildren: './views/monitor/analysis-pdf/analysis-pdf.module#AnalysisPdfModule'
      },
      {
        path: 'lot-preview',
        loadChildren: './views/cpd/lot-pdf/lot-pdf.module#LotPdfModule'
      },
      {
        path: 'ssar-preview',
        loadChildren: './views/cpd/ssar-pdf/ssar-pdf.module#SsarPdfModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    // canActivate: [AuthGaurd],
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'Schools',
        loadChildren: './views/Settings/school/school.module#SchoolModule'
      },
      {
        path: 'Grades',
        loadChildren: './views/Settings/standards/standards.module#StandardsModule'
      },
      {
        path: 'Subjects',
        loadChildren: './views/Settings/subjects/subjects.module#SubjectsModule'
      },
      {
        path: 'Topics',
        loadChildren: './views/Settings/topics/topics.module#TopicsModule'
      },
      {
        path: 'Skills',
        loadChildren: './views/Settings/skills/skills.module#SkillsModule'
      },
      {
        path: 'Questions',
        loadChildren: './views/Settings/questions/questions.module#QuestionsModule'
      },
      {
        path: 'Role',
        loadChildren: './views/Admin/role/role.module#RoleModule'
      },
      {
        path: 'User',
        loadChildren: './views/Admin/user/user.module#UserModule'
      },
      {
        path: 'Students',
        loadChildren: './views/Admin/students/students.module#StudentsModule'
      },
      {
        path: 'ImageUpload',
        loadChildren: './views/Settings/imageupload/imageupload.module#ImageuploadModule'
      },
      {
        path: 'Assessments',
        loadChildren: './views/Settings/assessments/assessments.module#AssessmentsModule'
      },
      {
        path: 'ActivityUpload',
        loadChildren: './views/Activity/upload-activity/upload-activity.module#UploadActivityModule'
      },
      {
        path: 'ClassRadarReport',
        loadChildren: './views/Activity/class-performance-analysis/class-performance-analysis.module#ClassPerformanceAnalysisModule'
      },
      {
        path: 'ClassBenchmarking',
        loadChildren: './views/Activity/class-benchmarking/class-benchmarking.module#ClassBenchmarkingModule'
      },
      {
        path: 'ClasswisePerformance',
        loadChildren: './views/Activity/classwise-performance-report/classwise-performance-report.module#ClasswisePerformanceReportModule'
      },
      {
        path: 'ActivityLabel',
        loadChildren: './views/Activity/upload-label/upload-label.module#UploadLabelModule'
      },
      {
        path: 'ActivityConfig',
        loadChildren: './views/Activity/activity-config/activity-config.module#ActivityConfigModule'
      },
      {
        path: 'LearningSummary',
        loadChildren: './views/report/learning-summary/learning-summary.module#LearningSummaryModule'
      },
      {
        path: 'Curriculums',
        loadChildren: './views/Settings/curriculums/curriculums.module#CurriculumsModule'
      },
      {
        path: 'term-analysis-report',
        loadChildren: './views/report/whole-class-performace/whole-class-performace.module#WholeClassPerformaceModule'
      },
      {
        path: 'comparative-analysis-report',
        loadChildren: './views/report/gender-wise/gender-wise.module#GenderWiseModule'
      },
      {
        path: 'ClassPerformanceReport',
        loadChildren: './views/report/whole-class-knowledge-skill/whole-class-knowledge-skill.module#WholeClassKnowledgeSkillModule'
      },
      {
        path: 'student-performance-report',
        loadChildren: './views/report/individual-student-performance/individual-student-performance.module#IndividualStudentPerformanceModule'
      },
      {
        path: 'topic-wise-performance-report',
        loadChildren: './views/report/chapter-wise-assessment/chapter-wise-assessment.module#ChapterWiseAssessmentModule'
      },
      {
        path: 'cognitive-performance-report',
        loadChildren: './views/report/cognitive-domain-assessment/cognitive-domain-assessment.module#CognitiveDomainAssessmentModule'
      },
      {
        path: 'cognitive-domain-internal-assessment',
        loadChildren: './views/report/cognitive-domain-internal-assessment/cognitive-domain-internal-assessment.module#CognitiveDomainInternalAssessmentModule'
      },
      {
        path: 'timeboundQuestions',
        loadChildren: './views/timebound/timebound-questions/timebound-questions.module#TimeboundQuestionsModule'
      },
      {
        path: 'timeboundAssessment',
        loadChildren: './views/timebound/timebound-assessment/timebound-assessment.module#TimeboundAssessmentModule'
      },
      {
        path: 'teachers',
        loadChildren: './views/Admin/teacher/teacher.module#TeacherModule'
      },
      {
        path: 'cpd-domains',
        loadChildren: './views/cpd/tchdomain/tchdomain.module#TchdomainModule'
      },
      {
        path: 'cpd-categories',
        loadChildren: './views/cpd/tchcategory/tchcategory.module#TchcategoryModule'
      },
      {
        path: 'cpd-topics',
        loadChildren: './views/cpd/tchtopic/tchtopic.module#TchtopicModule'
      },
      {
        path: 'cpd-subtopics',
        loadChildren: './views/cpd/tchsubtopic/tchsubtopic.module#TchsubtopicModule'
      },
      {
        path: 'cpd-questions',
        loadChildren: './views/cpd/tchquestion/tchquestion.module#TchquestionModule'
      },
      {
        path: 'cpd-assessments',
        loadChildren: './views/cpd/tchassessment/tchassessment.module#TchassessmentModule'
      },
      {
        path: 'cpd-timebound-assessments',
        loadChildren: './views/cpd/tchtimebound-assessment/tchtimebound-assessment.module#TchtimeboundAssessmentModule'
      },
      {
        path: 'cpd-timebound-questions',
        loadChildren: './views/cpd/tchtimeboundquestion/tchtimeboundquestion.module#TchtimeboundquestionModule'
      },
      {
        path: 'lesson-observation-tool',
        loadChildren: './views/cpd/lot/lot.module#LotModule'
      },
      {
        path: 'ssar',
        loadChildren: './views/cpd/ssar/ssar.module#SsarModule'
      },
      {
        path: 'class-assessment-report',
        loadChildren: './views/assessment-report/assessment-whole-class-knowledge-skill/assessment-whole-class-knowledge-skill.module#AssessmentWholeClassKnowledgeSkillModule'
      },
      {
        path: 'student-assessment-report',
        loadChildren: './views/assessment-report/assessment-individual-student-performance/assessment-individual-student-performance.module#AssessmentIndividualStudentPerformanceModule'
      },
      {
        path: 'topic-wise-assessment-report',
        loadChildren: './views/assessment-report/assessment-chapter-wise/assessment-chapter-wise.module#AssessmentChapterWiseModule'
      },
      {
        path: 'cognitive-assessment-report',
        loadChildren: './views/assessment-report/assessment-cognitive-domain/assessment-cognitive-domain.module#AssessmentCognitiveDomainModule'
      },
      {
        path: 'assessment-student-summary',
        loadChildren: './views/assessment-report/assessment-student-summary/assessment-student-summary.module#AssessmentStudentSummaryModule'
      },
      {
        path: 'objectives',
        loadChildren: './views/monitor/objectives/objectives.module#ObjectivesModule'
      },
      {
        path: 'tracker',
        loadChildren: './views/monitor/markbook/markbook.module#MarkbookModule'
      },
      {
        path: 'tracker-v2',
        loadChildren: './views/monitor/markbookv2/markbookv2.module#Markbookv2Module'
      },
      {
        path: 'lo-progress-summary-report',
        loadChildren: './views/monitor/lo-progress-summary-report/lo-progress-summary-report.module#LoProgressSummaryReportModule'
      },
      {
        path: 'lo-progress-circle-report',
        loadChildren: './views/monitor/lo-progress-circle-report/lo-progress-circle-report.module#LoProgressCircleReportModule'
      },
      {
        path: 'individual-student-progress-report',
        loadChildren: './views/monitor/individual-student-progress-report/individual-student-progress-report.module#IndividualStudentProgressReportModule'
      },
      {
        path: 'benchmarks',
        loadChildren: './views/bm/benchmark/benchmark.module#BenchmarkModule'
      },
      {
        path: 'benchmarkquestions',
        loadChildren: './views/bm/benchmark-questions/benchmark-questions.module#BenchmarkQuestionsModule'
      },
      {
        path: 'analysis-config',
        loadChildren: './views/monitor/analysis-config/analysis-config.module#AnalysisConfigModule'
      },
      {
        path: 'ImageConfig',
        loadChildren: './views/Settings/image-config/image-config.module#ImageConfigModule'
      },
    ]
  },

  {
    path: '**',
    redirectTo: 'others/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, initialNavigation: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
